export const range = (n: number) => [...new Array(n).keys()];

export const sortByProperty = <T>(arr: T[], k: keyof T): T[] => {
  return [...arr].sort((v1, v2) => (v1[k] > v2[k] ? 1 : -1));
};

export const steppedRound = (v: number, step: number) => {
  return Math.round(v / step) * step;
};
